"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ border = '1px solid var(--gray-10)', borderRadius = '50%', background = 'transparent', } = {}) {
    return {
        position: 'absolute',
        inset: 0,
        border,
        borderRadius,
        background,
        content: '""',
        pointerEvents: 'none',
    };
}
exports.default = default_1;
